import { FunctionComponent, SVGProps } from "react";
import AppfolioIcon from "shared/icons/brands/appfolio_logo.svg?react";
import BuildiumIcon from "shared/icons/brands/buildium_logo.svg?react";
import EntrataIcon from "shared/icons/brands/entrata_logo.svg?react";
import GoogleAnalyticsIcon from "shared/icons/brands/GoogleAnalytics-brand-icon.svg?react";
import HubSpotIcon from "shared/icons/brands/hubspot.svg?react";
import ManageAmericaIcon from "shared/icons/brands/manage_america_logo.svg?react";
import PropertywareIcon from "shared/icons/brands/propertyware_logo.svg?react";
import QuextIcon from "shared/icons/brands/quext_logo.svg?react";
import RentManagerIcon from "shared/icons/brands/rent_manager_logo.svg?react";
import RentersWarehouseIcon from "shared/icons/brands/renters_warehouse_logo.svg?react";
import RentvineIcon from "shared/icons/brands/rentvine_logo.svg?react";
import ResmanIcon from "shared/icons/brands/resman_logo.svg?react";
import RevelaIcon from "shared/icons/brands/revela_logo.svg?react";
import YardiIcon from "shared/icons/brands/yardi_logo.svg?react";
import { PropertyManagementSystem } from "shared/types/partner";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";

interface IntegrationLogo {
  Icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  src?: string;
  bg: string;
  imgClassName?: string;
  wrapperClassName?: string;
}

export const INTEGRATION_LOGO: Partial<
  Record<PropertyManagementSystem | IntegrationId, IntegrationLogo>
> = {
  [IntegrationId.CODEBOX]: {
    src: "/assets/codebox_logo.png",
    bg: "#007CCE",
    imgClassName: "w-[33px] h-[5px]"
  },
  [IntegrationId.HUBSPOT]: {
    Icon: HubSpotIcon,
    bg: "transparent"
  },
  [IntegrationId.GA]: {
    Icon: GoogleAnalyticsIcon,
    bg: "transparent"
  },
  [IntegrationId.ZILLOW]: {
    src: "/assets/zillow_logo.png",
    bg: "transparent",
    imgClassName: "w-full h-full rounded-lg"
  },
  [IntegrationId.ZUMPER]: {
    src: "/assets/zumper_logo.svg",
    bg: "transparent",
    imgClassName: "w-full h-full rounded-lg"
  },
  [IntegrationId.APARTMENTS_COM]: {
    src: "/assets/apartments_com_logo.png",
    bg: "transparent",
    imgClassName: "w-full h-full rounded-lg"
  },
  [IntegrationId.BOOM_FI]: {
    src: "/assets/boom_logo.svg",
    bg: "#1C1D22",
    imgClassName: "w-6 h-6"
  },
  [PropertyManagementSystem.Appfolio]: {
    Icon: AppfolioIcon,
    bg: "transparent"
  },
  [PropertyManagementSystem.Buildium]: {
    Icon: BuildiumIcon,
    bg: "transparent"
  },
  [PropertyManagementSystem.Entrata]: { Icon: EntrataIcon, bg: "transparent" },
  [PropertyManagementSystem.ManageAmerica]: {
    Icon: ManageAmericaIcon,
    bg: "#8082FF",
    wrapperClassName: "p-1.5"
  },
  [PropertyManagementSystem.Propertyware]: {
    Icon: PropertywareIcon,
    bg: "transparent"
  },
  [PropertyManagementSystem.Quext]: { Icon: QuextIcon, bg: "transparent" },
  [PropertyManagementSystem.RentManager]: {
    Icon: RentManagerIcon,
    bg: "#3777BC"
  },
  [PropertyManagementSystem.RentersWarehouse]: {
    Icon: RentersWarehouseIcon,
    bg: "#4184D3"
  },
  [PropertyManagementSystem.Resman]: { Icon: ResmanIcon, bg: "transparent" },
  [PropertyManagementSystem.Rentvine]: { Icon: RentvineIcon, bg: "#00A54F" },
  [PropertyManagementSystem.Yardi]: {
    Icon: YardiIcon,
    bg: "#0075D3",
    wrapperClassName: "p-1.5"
  },
  [PropertyManagementSystem.Revela]: { Icon: RevelaIcon, bg: "transparent" }
};
